import React, { Fragment, ReactNode } from 'react';

import { menuKeys } from '../../../../../locales/keys';

import { MainLayout } from '../../../../common/layouts/MainLayout';

import { MainScrollWrapper } from '../../../../common/helpers/MainScrollWrapper';

type ThreeDStockShowLayoutProps = {
  action?: string;
  isModal?: boolean;
  children: ReactNode;
  header?: ReactNode;
  subHeader?: ReactNode;
  modalHeader?: ReactNode;
  secondaryMenu?: ReactNode;
  sidebar?: ReactNode;
};

function ThreeDStockShowLayout({
  isModal,
  action,
  children,
  header,
  secondaryMenu,
  subHeader,
  modalHeader,
  sidebar
}: ThreeDStockShowLayoutProps) {
  return isModal ? (
    <Fragment>
      {modalHeader}
      <div className="flex-1 flex overflow-hidden">
        <div className="flex-1 overflow-y-auto px-2 z-0 bg-white dark:bg-gray-900">
          <div>{children}</div>

          {secondaryMenu}
        </div>

        <div className="relative">{sidebar ? sidebar : null}</div>
      </div>
    </Fragment>
  ) : (
    <MainLayout action={action} i18nTitle={menuKeys.tabs.stock3d}>
      <div className="flex flex-1">
        <div id="page-wrap" className="flex flex-col w-full z-0">
          <div id="page-header-wrap" className="relative z-5">
            <div className="flex-shrink-0 flex h-16 border-b border-gray-200 dark:border-gray-700">
              {header}
            </div>

            {subHeader}
          </div>

          <div className="relative flex-1 xl:z-0">
            <div className="absolute inset-0 flex overflow-hidden">
              <MainScrollWrapper withScrollRestore withScrollToTop>
                {children}
              </MainScrollWrapper>
              {sidebar ? sidebar : null}
            </div>
          </div>
        </div>
        {secondaryMenu}
      </div>
    </MainLayout>
  );
}

export default ThreeDStockShowLayout;
